// D-140 (2026-05-20): Sentry init ANTES do render — captura erros de bootstrap.
import { initSentry } from './sentry'
initSentry()

import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* D-140: ErrorBoundary do Sentry envolve o app inteiro. Mostra fallback
        amigável e reporta o erro pro Sentry com stacktrace e component tree. */}
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif', maxWidth: 480, margin: '40px auto' }}>
          <h1 style={{ color: '#a04030', marginBottom: 12 }}>Algo deu errado</h1>
          <p style={{ color: '#555', marginBottom: 16 }}>
            A tela travou. Já te avisamos do erro. Você pode tentar de novo:
          </p>
          <button
            onClick={resetError}
            style={{ padding: '8px 16px', background: '#a04030', color: '#fff', border: 0, borderRadius: 6, cursor: 'pointer' }}
          >
            Recarregar
          </button>
          <pre style={{ marginTop: 16, fontSize: 11, color: '#999', whiteSpace: 'pre-wrap' }}>
            {(error as Error)?.message || String(error)}
          </pre>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
